import styled from 'styled-components';

export const DatePickerWrapper = styled.div`
  padding: 0;

  .icon {
    right: auto;
    left: 15px;
  }

  input {
    padding: 7px 10px 7px 44px;
    background: var(--color-surface);
  }
`;
